<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Leave Requests</h1>
      <router-link to="/request/leave/add" class="button is-primary is-small is-uppercase">Add</router-link>
    </div>
    <div class="box" style="margin-top: 12px;">
      <component-search></component-search>
      <component-filters></component-filters>
    </div>
    <leave-table class="is-hidden-mobile"></leave-table>
    <leave-list class="is-hidden-tablet"></leave-list>
    <app-paginate module="leave"></app-paginate>
  </div>
</template>
<script>
import ComponentSearch from "./components/search";
import ComponentFilters from "./components/filters";
import LeaveTable from "./components/leave-table";
import LeaveList from "./components/leave-list";
export default {
  components: {
    ComponentSearch,
    ComponentFilters,
    LeaveTable,
    LeaveList
  },
  mounted() {
    let component = this;
    component.$store.commit("leave/page", 1);
    component.$store.commit("leave/limit", 10);
    component.$store.commit("leave/role", "all");
    component.$store.commit("leave/docs", []);
    component.$store.commit("leave/totalDocs", 0);
    component.$store.commit("leave/totalPages", 0);
    component.$store.dispatch("leave/index");
  }
};
</script>
<style lang="scss" scoped>
.is-flex {
  .view-title {
    flex-basis: 0;
    flex-grow: 1;
  }
  .add-button {
    margin-top: 12px;
  }
}
</style>
